module.exports = __webpack_public_path__ + "img/countesse_perverse_desk.fae7910b.jpg";